// removed by extract-text-webpack-plugin
module.exports = {"scroll-to-button-wrapper":"ScrollToButton_scroll-to-button-wrapper---sb","scrollToButtonWrapper":"ScrollToButton_scroll-to-button-wrapper---sb","hidden":"ScrollToButton_hidden---sb","label":"ScrollToButton_label---sb","btn":"ScrollToButton_btn---sb","bounce":"ScrollToButton_bounce---sb","up":"ScrollToButton_up---sb","down":"ScrollToButton_down---sb","upArrow":"ScrollToButton_upArrow---sb","downArrow":"ScrollToButton_downArrow---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ScrollToButton/styles.less
// module id = 1460
// module chunks = 0